import { useEffect, useState } from "react";
import { applyPricing, applySettings } from "../data/pricing";

// Fetches admin-managed pricing + extras (night surcharge, child-seat prices)
// and applies them to the shared in-memory config. Returns a version counter
// that bumps once loaded, forcing a re-render so fares reflect admin settings.
export function usePricing() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let active = true;
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/pricing`)
      .then((r) => r.json())
      .then((list) => { if (active) { applyPricing(list); setVersion((v) => v + 1); } })
      .catch(() => {});
    fetch(`${base}/api/settings`)
      .then((r) => r.json())
      .then((s) => { if (active) { applySettings(s); setVersion((v) => v + 1); } })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return version;
}
